import messages from '@src/routes/LinkProfile/messages'

const IMAGE_BASE_PATH =
  '/deepweb/assets/sigmaaldrich/marketing/global/images/cpam-helper-images'

export type ImagePath = {
  src: string
  placeholder: string
}

export type ImagePaths = {
  quoteQuoteNumPath: ImagePath
  quoteCustNumPath: ImagePath
  orderConfirmOrderNumPath: ImagePath
  orderConfirmCustNumPath: ImagePath
  invoiceInvoiceNumPath: ImagePath
  invoiceCustNumPath: ImagePath
  orderInvoiceOrderNumberPath: ImagePath
}

export type HelperData = {
  customerDesc: string
  transactionNumberOrderNumberDesc: string
  transactionNumberQuoteReferDesc: string
  transactionNumberInvoiceNumDesc: string
  orderNumberDesc: string
  images: ImagePaths
}

const makeImages = (system: string) => {
  const make = (type: string) => ({
    src: `${IMAGE_BASE_PATH}/${system}-${type}/${system}-${type}.png`,
    placeholder: `${IMAGE_BASE_PATH}/${system}-${type}/${system}-${type}_w300.png`,
  })
  return {
    quoteQuoteNumPath: make('quote-quotenum'),
    quoteCustNumPath: make('quote-custnum'),
    orderConfirmOrderNumPath: make('orderconfirm-ordernum'),
    orderConfirmCustNumPath: make('orderconfirm-custnum'),
    invoiceInvoiceNumPath: make('invoice-invoicenum'),
    invoiceCustNumPath: make('invoice-custnum'),
    orderInvoiceOrderNumberPath: make('invoice-ordernum'),
  }
}

const basicDataPRP: HelperData = {
  customerDesc: messages.FIND_YOUR_CUSTOMER_NUMBER_DESC_PRP.id,
  transactionNumberOrderNumberDesc:
    messages.LINK_PROFILE_FIND_YOUR_TRANSACTION_NUMBER_ORDER_NUMBER_DESC_PRP.id,
  transactionNumberQuoteReferDesc:
    messages.LINK_PROFILE_FIND_YOUR_TRANSACTION_NUMBER_QUOTE_REFER_DESC_PRP.id,
  transactionNumberInvoiceNumDesc:
    messages.LINK_PROFILE_FIND_YOUR_TRANSACTION_NUMBER_INVOICE_NUM_DESC_PRP.id,
  orderNumberDesc:
    messages.LINK_PROFILE_FIND_YOUR_ORDER_NUMBER_ORDER_NUM_DESC_PRP.id,
  images: makeImages('PRP'),
}

const basicDataPRE: HelperData = {
  customerDesc: messages.FIND_YOUR_CUSTOMER_NUMBER_DESC_PRE.id,
  transactionNumberOrderNumberDesc:
    messages.LINK_PROFILE_FIND_YOUR_TRANSACTION_NUMBER_ORDER_NUMBER_DESC_PRE.id,
  transactionNumberQuoteReferDesc:
    messages.LINK_PROFILE_FIND_YOUR_TRANSACTION_NUMBER_QUOTE_REFER_DESC_PRE.id,
  transactionNumberInvoiceNumDesc:
    messages.LINK_PROFILE_FIND_YOUR_TRANSACTION_NUMBER_INVOICE_NUM_DESC_PRE.id,
  orderNumberDesc:
    messages.LINK_PROFILE_FIND_YOUR_ORDER_NUMBER_ORDER_NUM_DESC_PRE.id,
  images: makeImages('PRE'),
}

const basicDataPRD: HelperData = {
  customerDesc: messages.FIND_YOUR_CUSTOMER_NUMBER_DESC.id,
  transactionNumberOrderNumberDesc:
    messages.LINK_PROFILE_FIND_YOUR_TRANSACTION_NUMBER_ORDER_NUMBER_DESC.id,
  transactionNumberQuoteReferDesc:
    messages.LINK_PROFILE_FIND_YOUR_TRANSACTION_NUMBER_QUOTE_REFER_DESC.id,
  transactionNumberInvoiceNumDesc:
    messages.LINK_PROFILE_FIND_YOUR_TRANSACTION_NUMBER_INVOICE_NUM_DESC.id,
  orderNumberDesc:
    messages.LINK_PROFILE_FIND_YOUR_ORDER_NUMBER_ORDER_NUM_DESC_PRD.id,
  images: makeImages('PRD'),
}

export const ErpSystemIdType = {
  PRD: 'PRD',
  STN: 'STN',
  DEN: 'DEN',
  PRE: 'PRE',
  Q47: 'Q47',
  DEU: 'DEU',
  PRP: 'PRP',
  QRP: 'QRP',
  URP: 'URP',
  DRP: 'DRP',
} as const
export type ErpSystemIdType =
  (typeof ErpSystemIdType)[keyof typeof ErpSystemIdType]

export const helperImageMapping = (type: any = ''): HelperData | null => {
  const upperCaseType: any = type.toUpperCase()
  const erpSystemIdPrd: ErpSystemIdType[] = [
    ErpSystemIdType.PRD,
    ErpSystemIdType.STN,
    ErpSystemIdType.DEN,
  ]
  const erpSystemIdPre: ErpSystemIdType[] = [
    ErpSystemIdType.PRE,
    ErpSystemIdType.Q47,
    ErpSystemIdType.DEU,
  ]
  const erpSystemIdPrp: ErpSystemIdType[] = [
    ErpSystemIdType.PRP,
    ErpSystemIdType.QRP,
    ErpSystemIdType.URP,
    ErpSystemIdType.DRP,
  ]

  if (erpSystemIdPrd.includes(upperCaseType)) {
    return basicDataPRD
  } else if (erpSystemIdPre.includes(upperCaseType)) {
    return basicDataPRE
  } else if (erpSystemIdPrp.includes(upperCaseType)) {
    return basicDataPRP
  }
  return null
}

export const checkIfIsPRDorPREorPRPCountry = (type: any = '') => {
  return Object.values(ErpSystemIdType).includes(type.toUpperCase() as any)
}
